import classNames from 'classnames'

interface CardProps {
  children?: React.ReactNode
  className?: string
  onClick?: () => void
  style?: React.CSSProperties
}

export const Card = ({ children, className, style, onClick }: CardProps) => {
  return (
    <div
      className={classNames('bg-gray-50 rounded-2xl p-4', className)}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  )
}
